import { Box, Grid, Typography, useTheme } from '@mui/material'
import React from 'react'
import { useTranslation,Trans } from 'react-i18next'

import { accessManagementItem } from './items'
const AccessManagementSection: React.FC = () => {
  const theme = useTheme()
  const {t} = useTranslation()
  const data = accessManagementItem()

  return (
    <Box margin='0 auto' mb={{ xs: 5, md: 8.75 }} mt={{ xs: '1.8rem', md: '3.813rem' }}>
      <Typography
        variant='h2'
        sx={{ mb: 1, color: theme.palette.publicPages.contrastText }}
        fontSize={{ xs: '2rem', md: '2.5rem' }}
        lineHeight={{ xs: '2.5rem', md: '3rem' }}
        fontWeight={600}
      >
        <Trans i18nKey={'featuresPage.accessManagement'} components={{ highlight: <span style={{color:theme.palette.publicPages.light}} />}} />

      </Typography>

      <Box display='flex' justifyContent='center'>
        <Typography
          variant='h5'
          sx={{ color: theme.palette.publicPages.colorThirteen }}
          fontSize={{ xs: '.8rem', md: '1rem' }}
          lineHeight={{ xs: '1.563rem', md: '1.563rem' }}
          fontWeight={400}
          mt={'0.625rem'}
          maxWidth={'33.313rem'}
        >
          {t('featuresPage.accessManagementSubHeading')}
        </Typography>
      </Box>
      <Box
        sx={{ backgroundColor: theme.palette.publicPages.colorFourteen }}
        paddingY={'4.25rem'}
        mt='3.25rem'
        width='100%'
        alignSelf='center'
        paddingX={{ xl: '12rem', xs: '0rem' }}
      >
        <Grid
          container
          spacing={2}
          justifyContent='center'
          maxWidth='95rem'
          sx={{ margin: { xl: '0 auto' } }}
        >
          {data.map((card, index) => (
            <Grid
              item
              xs={12}
              sm={12}
              md={5}
              xl={5}
              key={index}
              display='flex'
              justifyContent='center'
            >
              <Box
                sx={{
                  borderRadius: '1.25rem',
                  border: `solid 0.063rem ${theme.palette.publicPages.colorFive}`,
                  backgroundColor: theme.palette.common.white,
                  padding: '1rem 1.5rem',
                }}
                paddingBottom={{ lg: '1.25rem', md: '0rem', sm: '0rem' }}
                textAlign='left'
                height='11.5rem'
                width={{ xl: '36.875rem', lg: '36.875rem', md: '31.25rem', sm: '36.875rem' }}
                margin={{ sm: '0rem', xs: '0.6rem' }}
              >
                <Box component='img' src={card.icon} />
                <Typography
                  mt={{ sm: '0.25rem', mt: 'none' }}
                  fontWeight='500'
                  sx={{
                    fontSize: { lg: '1.125rem', md: '0.875rem' },
                    lineHeight: { lg: '1.563rem', md: '0.75rem' },
                  }}
                >
                  {t(`featuresPage.${card.title}`)}
                </Typography>
                <Typography
                  fontSize={{ lg: '0.875rem', md: '0.813rem', xs: '0.813rem' }}
                  fontWeight='300'
                  lineHeight={{ lg: '1.313rem', md: '1.125rem' }}
                  mt='0.438rem'
                  color={theme.palette.publicPages.colorThirteen}
                  mb={{ sm: '1.125rem', xs: '0.313rem' }}
                >
                  {t(`featuresPage.${card.description}`)}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  )
}

export default AccessManagementSection
